import {Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-sticky-header',
    templateUrl: './sticky-header.component.html',
    styleUrls: ['./sticky-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StickyHeaderComponent implements OnInit, OnDestroy {

    ngOnInit() {
        document.querySelector('body').classList.add('has-sticky-header');
    }

    ngOnDestroy() {
        document.querySelector('body').classList.remove('has-sticky-header');
    }

}
